import { LicenseDefinitionsScreen } from "./license-definitions.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const LicenseDefinitionsRoutes: RouteDefinition[] = [
	{
		path: Paths.licenseDefinitions.path,
		element: <LicenseDefinitionsScreen />,
		requiredPermissions: ["UserInAccountPermission_LicenseAdmin_Read"],
	},
];
